
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M456.271 501.823C449.48 508.609 441.242 512 431.541 512H82.453c-9.691 0-17.938-3.391-24.725-10.177-6.789-6.786-10.182-15.033-10.182-24.727V267.639c0-9.697 3.393-17.942 10.182-24.726 6.787-6.791 15.033-10.179 24.725-10.179h250.491l9.093-13.059c14.68-21.089 19.752-44.292 15.215-69.598-4.533-25.308-17.347-45.299-38.438-59.981-21.092-14.68-44.289-19.753-69.601-15.22-25.308 4.533-45.306 17.347-59.985 38.436l-39.888 57.307-57.305-39.886 39.89-57.307c25.482-36.61 60.491-58.907 105.038-66.89 44.541-7.985 85.12.765 121.736 26.25 36.612 25.487 58.906 60.5 66.888 105.044 6.08 33.94 2.419 65.569-10.927 94.902h16.871c9.703 0 17.94 3.389 24.731 10.179 6.79 6.789 10.19 15.033 10.19 24.726v209.458c.001 9.695-3.399 17.942-10.181 24.728z"}})])
          )
        }
      }
    